import slugify from 'slugify'

export const slugifyString = (string: string) => {
  // more config options can be found at https://www.npmjs.com/package/slugify?activeTab=readme
  return slugify(string, {
    lower: true, // convert to lower case, defaults to `false`
    locale: 'vi', // language code of the locale to use
  })
}
